import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { Button } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  button: {
    borderRadius: 50,
    width: 'auto',
    padding: 8,
    position: 'relative',
    fontWeight: 600,
    borderColor: theme.palette.primary.main,
    borderWidth: 2,
    borderStyle: 'solid',
  },
  noUppercase: {
    textTransform: 'none',
  },
  fullWidth: {
    width: '100%',
  },
  icon: {
    marginRight: 8,
  },
}));

export default function BaseButton({
  IconComponent,
  noUppercase,
  children,
  onClick,
  fullWidth,
  disabled,
  ...props
}) {
  const classes = useStyles();

  return (
    <div className={clsx(fullWidth && classes.fullWidth)}>
      <Button
        className={clsx(
          fullWidth && classes.fullWidth,
          (noUppercase) && classes.noUppercase,
          (props && props.variant === 'contained') && classes.contained,
          classes.button,
        )}
        onClick={onClick}
        color="default"
        disabled={disabled}
        fullWidth
        {...props}
      >
        {IconComponent
          && (
          <IconComponent
            className={classes.icon}
            color={(props && props.color === 'primary' ? 'white' : 'primary')}
          />
          )}
        {children}
      </Button>
    </div>
  );
}
